import autoRoutingComponent from "./auto_routing.component";

let autoRoutingModule = angular
  .module("autoRouting", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/autoRouting");

    $stateProvider.state("autoRouting", {
      url: "/v2/index.html#/automated-routing-control",
      component: "autoRouting",
      data: {
        requireLogin: true,
      },
    });
  })
  .component("autoRouting", autoRoutingComponent).name;

export default autoRoutingModule;



// WEBPACK FOOTER //
// ./client/app/components/auto_routing/index.js